import { Form, Input, Row } from 'antd';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
import config from '~/config';
import { checkKeyDownNumberInput } from '~/utils';
import styles from './FormRegister.module.scss';

const cx = classNames.bind(styles);

// const Gender = styled.div`
//     .ant-select.ant-select-in-form-item {
//         height: 44px;
//     }
//     .ant-select-selector {
//         height: 44px;
//     }
//     .ant-select:not(.ant-select-customize-input) .ant-select-selector {
//         height: 44px;
//     }
//     .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
//         height: none;
//     }
//     .ant-select:not(.ant-select-customize-input) .ant-select-selector {
//         height: 44px;
//     }
//     .ant-select-selection-placeholder {
//         height: 44px;
//         align-items: center;
//         display: flex;
//     }
//     .ant-select-selection-item {
//         height: 44px;
//         align-items: center;
//         display: flex;
//     }
//     .ant-select-selection.ant-select-selection--single {
//         height: 44px;
//     }

//     .ant-select-selection-selected-value {
//         height: 44px;
//     }
// `;

const RegisterModal = ({ formRegister, onFinishRegister, gender, setGender, errPhone }) => {
    const navigate = useNavigate();

    // const handleChangeGender = (value) => {
    //     setGender(value);
    // };
    return (
        <Form onFinish={onFinishRegister} form={formRegister}>
            <Form.Item>
                <Row justify="center" className={cx('name_page')}>
                    Register
                </Row>
            </Form.Item>
            <Form.Item>
                <Row justify="center" className={cx('bio')}>
                    Register to track orders, save a list of favorite products, and receive many attractive offers.
                </Row>
            </Form.Item>
            <Row justify="center" className={cx('err')}>
                {errPhone}
            </Row>
            {/* <Form.Item name="fullname" rules={[{ max: 50, message: 'Maximum name 50 characters' }]}>
                <Input placeholder="Name" className={cx('item_input')} />
            </Form.Item> */}

            <Form.Item
                name="phone"
                rules={[
                    { required: true, message: 'Please enter phone number' },
                    {
                        // pattern: new RegExp(/^[0-9\S]*$/),
                        pattern: new RegExp(/(0[3|5|7|8|9])+([0-9])/),
                        message: 'Wrong phone number format',
                    },
                    { min: 10, message: 'Phone number must have 10 digits' },
                ]}
            >
                <Input
                    placeholder="Phone number *"
                    onKeyDown={checkKeyDownNumberInput}
                    maxLength={10}
                    className={cx('item_input')}
                />
            </Form.Item>
            {/* <Form.Item name="email" rules={[{ type: 'email', message: 'Incorrect email address' }]}>
                <Input placeholder="Email" className={cx('item_input')} />
            </Form.Item>

            <Form.Item name="gender">
                <Gender>
                    <Select placeholder="Gender" value={gender} onChange={(value) => handleChangeGender(value)}>
                        {genderList?.map((item) => {
                            return (
                                <Select.Option value={item?.value} key={item?.value}>
                                    {item?.title}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </Gender>
            </Form.Item> */}

            <Form.Item style={{ marginTop: '50px' }}>
                <button htmlType="submit" className={cx('btn_login')}>
                    Register
                </button>
            </Form.Item>

            <Row justify="center" className={cx('sign_in')}>
                Do you already have an account? <span onClick={() => navigate(config.routes.login)}> Login</span>
            </Row>
        </Form>
    );
};

export default RegisterModal;
